import { WordsetContextProvider } from '../../containers/WordSetContextProvider/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';

export default function WordSet(props) {
  return (
    <WordsetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
    >
      <SetsSelectedWrapper props={props} />
    </WordsetContextProvider>
  );
}
